/**
 * Created by beyondin on 2018/7/27.
 */
import aboutUs from '@/view/aboutUs/index'
const route = [{
    path: '/aboutUs.html',
    meta: {
      title: '关于我们'
    },
    component: aboutUs
  }
];

export default route;



// WEBPACK FOOTER //
// ./src/router/aboutUs.js